<template>
  <b-card header="Upload File">
    <div class="d-flex">
      <!-- NAME AND CONTENT TYPE -->
      <!-- LEFT CONTAINER -->
      <div class="grid-style">
        <b-form-group label="Friendly Name" style="grid-column: 1/4">
          <b-form-input v-model="file.friendlyName"></b-form-input>
        </b-form-group>

        <b-form-group label="Content Type" style="grid-column: 1/4">
          <b-form-select v-model="file.fileCategoryId">
            <template v-slot:first>
              <option :value="null" disabled>-- Select content type --</option>
            </template>
            <option v-for="file in fileContentType" :key="file.id" :value="file.id">{{ file.name }}</option>
          </b-form-select>
        </b-form-group>

        <b-form-group label="File Password" style="grid-column: 1/4">
          <b-form-input v-model="file.password" type="password" placeholder="Password" />
        </b-form-group>
      </div>

      <!-- USERS AMD COMMENTS -->
      <!-- MIDDLE CONTAINER -->

      <div class="ml-3 grid-style">
        <b-form-group label="Select users to notify" style="grid-column: 1/4">
          <multiselect
            v-model="file.notifiedUsers"
            tag-placeholder="Add this as new value"
            label="text"
            track-by="value"
            :options="contactLookupsOptions"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :preselect-first="false"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Comments" style="grid-column: 1/4;margin-top:20px">
          <b-form-textarea v-model="file.fileNote"></b-form-textarea>
        </b-form-group>
      </div>

      <!-- BUTTON -->
      <!-- RIGHT CONTAINER -->
      <div class="ml-3 grid-style">
        <b-form-group label="File" style="grid-column: 1/3">
          <b-form-file v-model="file.file" accept="acceptExtensions" plain></b-form-file>
        </b-form-group>
        <b-button
          size="sm"
          variant="primary"
          class="upload-file-button"
          @click="uploadFile"
          :disabled="isUploadFilesValid"
        >
          Save & Upload
          <i class="fa fa-file mr-2"></i>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import multiselect from 'vue-multiselect';
import Grid from '@/shared/components/Grid';

//?pageNumber=1&pageSize=10&sortBy=id&sortOrder=ASC&filters={'statusId':null,'dateFrom':null,'dateTo':null}
export default {
  components: {
    Grid,
    multiselect
  },
  props: ['fileContentType', 'contactLookupsOptions', 'uploadFileFunction'],
  data() {
    return {
      file: {
        friendlyName: null,
        fileCategoryId: null,
        notifiedUsers: null,
        fileNote: null,
        file: null
      },
      acceptExtensions: [
        'image/jpg',
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/bmp',
        'text/plain',
        'application/pdf',
        'document/docx',
        'document/doc',
        'document/pptx',
        'document/ppt',
        'document/xlsx',
        'document/xls',
        'audio/mp3',
        'audio/m4a',
        'audio.wav',
        'application/x-zip-compressed',
        'video/mp4',
        'video/m4v',
        'video/mpg',
        'video/mov',
        'video/wmv',
        'video/mov',
        'video/avi',
        'video/swf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ]
    };
  },
  computed: {
    isUploadFilesValid() {
      return (
        this.file.friendlyName === null ||
        this.file.friendlyName.match(/^ *$/) !== null ||
        this.file.file === null ||
        this.file.fileCategoryId === null
      );
    },
    contactsOptions() {
      return this.convertToFormSelectObj(this.contactLookupsData, {
        value: 'id',
        text: 'contactFullName'
      });
    }
  },
  methods: {
    initializeFileObj() {
      for (let key in this.file) {
        this.file[key] = null;
      }
    },

    convertToFormSelectObj(arr, { value, text }) {
      let convertedObjArr = [];

      payload.forEach(a => {
        if (a[text] != '') {
          convertedObjArr.push({ value: a[value], text: a[text] });
        }
      });

      return convertedObjArr;
    },

    isValidName(name) {
      return !_.isEmpty(name) && !_.isNull(name) && name != ' ';
    },

    fileUploadedSet() {
      this.file.fileName = this.file.file.name;
      this.file.fileSize = this.file.file.size;
      this.file.type = this.file.file.type;
    },

    async uploadFile() {
      if (this.acceptExtensions.indexOf(this.file.file.type) === -1) {
        alert('Please choose the valid file format');
        return;
      }
      if (this.file.file.size > 50000000) {
        alert('File should be less than 50MB');
        return;
      }
      this.fileUploadedSet();
      await this.uploadFileFunction(this.file);
      this.initializeFileObj();
    }
  }
};
</script>

<style scoped>
.grid-style {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 40px);
  grid-gap: 0.5rem;
  width: 800px;
}

.upload-file-button {
  width: 150px;
  font-weight: 600 !important;
  letter-spacing: 0.1em;
  background-color: #66ccfe;
  text-transform: uppercase;
  grid-row: 2;
}
</style>
